import { Component, OnInit } from '@angular/core';
import { SplashService } from '../../services/view-components/splash.service';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.scss']
})
export class SplashComponent implements OnInit {
  showSplash = true;

  constructor(
    private splashService: SplashService
  ) {
  }

  ngOnInit() {
    this.splashService.isOpen.subscribe(value => {
      value ? this.open() : this.close();
    });
  }

  open(): void {
    this.showSplash = true;
  }

  close(): void {
    this.showSplash = false;
  }

}
